import React from "react";
import { withRouter } from "react-router-dom";
import Developer1 from "./Developer1";
import Developer2 from "./Developer2";
import Developer3 from "./Developer3";
import { Url } from '../../services/utilities/util';

class Developer extends React.Component {

    constructor(props) {
        super(props);

        if (typeof Url.get.filter !== 'undefined') {
            var filterValues = JSON.parse(Url.get.filter);
            this.state = {
                whichDeveloper: (filterValues.expiringInMonth === 20) ? 2 : (filterValues.expiringInMonth === 30) ? 3 : 1
            };
        } else {
            this.state = {
                whichDeveloper: 1
            };
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (typeof Url.get.filter !== 'undefined') {
            var filterValues = JSON.parse(Url.get.filter);
            var whichDeveloper = (filterValues.expiringInMonth === 20) ? 2 : (filterValues.expiringInMonth === 30) ? 3 : 1;
            if (this.state.whichDeveloper !== whichDeveloper) {
                this.setState({
                    whichDeveloper: whichDeveloper
                });
            }
        }
    }

    render() {
        return (
            <>
                {this.state.whichDeveloper === 1 &&
                    <Developer1 />
                }

                {this.state.whichDeveloper === 2 &&
                    <Developer2 />
                }

                {this.state.whichDeveloper === 3 &&
                    <Developer3 />
                }
            </>
        );
    }
}

export default withRouter(Developer);
